module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0084.jpg?v=8bb6f443";